import { useAuthStore } from '../store/authStore';

// Auth is automatic: on boot we forward Telegram initData to the backend.
// This screen only shows progress / error / a manual retry.
export function LoginScreen() {
  const { status, error, signIn } = useAuthStore();

  return (
    <div className="centered-screen">
      <div className="brand">Carma</div>
      <p className="muted">Замовлення таксі прямо в Telegram</p>

      {status === 'authenticating' && <div className="spinner" aria-label="Завантаження" />}

      {status === 'error' && (
        <>
          <p className="error-text">{error ?? 'Помилка входу'}</p>
          <button className="primary-button" onClick={() => signIn()}>
            Спробувати ще раз
          </button>
        </>
      )}

      {status === 'idle' && (
        <button className="primary-button" onClick={() => signIn()}>
          Увійти
        </button>
      )}
    </div>
  );
}
